"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadImgLogin = exports.uploadImg = void 0;
var _consts = require("../consts");
/*
 * @Author: liujunhong
 * @Date: 2023/8/30
 * @Desc: upload
 */

var uploadImgLogin = "".concat(_consts.UPLOAD_URL, "/upload/community/file");
exports.uploadImgLogin = uploadImgLogin;
var uploadImg = "".concat(_consts.UPLOAD_URL, "/upload/file");
exports.uploadImg = uploadImg;